import { Injectable } from "@angular/core";

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
}

const MENUITEMS = [
  // { state:'dashboard', name: 'Dashboard', type: 'link', icon: 'av_timer' },
 // { state: 'upload-video', type: 'link', name: 'Upload Video', icon: 'cloud_upload',iconUrl:'assets/images/load.png' },
  { state: 'video', type: 'link', name: 'My Video', icon: 'cloud_upload',iconUrl:'assets/images/video-camera (1).png'},
  { state: 'playlist', type: 'link', name: 'My PlayList', icon: 'cloud_upload',iconUrl:'assets/images/playlist (3).png'},
  { state: 'refcode', type: 'link', name: 'Ref Code', icon: 'cloud_upload',iconUrl:'assets/images/invitation (2).png'},
  { state: 'profile', type: 'link', name: 'My Profile', icon: 'cloud_upload',iconUrl:'assets/images/user (4).png'},
 ];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
